import React, { useEffect, useState } from "react";
import "./ControlPanel.scss";
import { useHistory } from "react-router-dom";
import "./ControlPanel.scss";
import ModalComponent from "components/UI/MaterialUIComponents/ModalComponent";
import { editar, obtenerDatos } from "services/crudFirebase";
import {
    Backdrop,
    CircularProgress,
    makeStyles,
    TextareaAutosize,
} from "@material-ui/core";
import Buttons from "components/UI/Button/Buttons";
import dayjs from "dayjs";

// Styles for charging backdrop
const useStyles = makeStyles((theme) => ({
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: "#fff",
    },
}));

const ControlPanel = () => {
    const history = useHistory();
    const classes = useStyles();
    const [stateModal, setStateModal] = useState(false);
    const [priceList, setPriceList] = useState("");
    const [priceListID, setPriceListID] = useState("");
    const [catalogueDownloadLink, setCatalogueDownloadLink] = useState("");
    const [TyC, setTyC] = useState("");
    const [TyCId, setTyCId] = useState("");
    const [activeCircularProgress, setActiveCircularProgress] = useState(false);
    const handleCloseBackdrop = () => setActiveCircularProgress(false);

    useEffect(async () => {
        const priceList = await obtenerDatos("ListaPrecios");
        const catalogueObj = await obtenerDatos("CatalogoFlexores");
        const dataStr = `data:text/json;charset=utf-8,${encodeURIComponent(
            JSON.stringify(catalogueObj)
        )}`;

        if (window.navigator.onLine) {
            setCatalogueDownloadLink(dataStr);
            setPriceList(priceList[0].LinkDrive);
            setPriceListID(priceList[0].id);
            readRegulations();
        }
        window.scrollTo(0, 0);
    }, []);

    if (
        window.localStorage.getItem("account") === "false" ||
        window.localStorage.getItem("account") === false
    ) {
        history.push("/ingresar");
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        editar({ id: priceListID, LinkDrive: priceList }, "ListaPrecios");
        setStateModal(false);
    };

    const editRegulations = async () => {
        setActiveCircularProgress(true);
        const currentDate = dayjs().format("YYYY-MM-DD");
        await editar(
            { id: TyCId, TerminosYCondiciones: TyC, LastUpdate: currentDate },
            "Regulaciones"
        );
        setStateModal(false);
		handleCloseBackdrop()
    };

    const readRegulations = async () => {
        const data = await obtenerDatos("Regulaciones");
        setTyC(data[0].TerminosYCondiciones);
        setTyCId(data[0].id);
        console.log(data[0].id);
    };

    return (
        <div className="controlPanel">
            <h2>Panel de control</h2>
            <p>
                Administra el contenido del sitio dirigiendote a las opciones
                del menú para editar los productos y las sucursales.
            </p>
            <span>
                Para actualizar el link de la lista de precios haz click{" "}
                <ModalComponent
                    stateModal={stateModal}
                    setStateModal={setStateModal}
                    slotOpenModal={<button>aquí.</button>}
                >
                    <form
                        className="controlPanel__updatePriceList"
                        onSubmit={handleSubmit}
                    >
                        <label>Actualizar lista de precios</label>
                        <input
                            type="text"
                            onChange={(e) => {
                                setPriceList(e.target.value);
                            }}
                            value={priceList}
                        />
                        <input type="submit" value="Actualizar" />
                    </form>
                </ModalComponent>
            </span>
            <br />
            <br />
            <span>
                Para realizar una modificación en los términos y condiciones haz
                click{" "}
                <ModalComponent
                    stateModal={stateModal}
                    setStateModal={setStateModal}
                    scrollable={true}
                    slotOpenModal={<button>aquí.</button>}
                >
                    <TextareaAutosize
                        aria-label="empty textarea"
                        placeholder="Términos y condiciones"
                        className="textAreaRegulationsEditor"
                        value={TyC}
                        onChange={(e) => setTyC(e.target.value)}
                    />
                    <Buttons className="btnPrimary" onClick={editRegulations}>
                        Editar
                    </Buttons>
                    <Backdrop
                        className={classes.backdrop}
                        open={activeCircularProgress}
                        onClick={handleCloseBackdrop}
                    >
                        <CircularProgress color="inherit" />
                    </Backdrop>
                </ModalComponent>{" "}
                Ten en cuenta que la edición debe redactarse usando la sintaxis
                de markdown.{" "}
                <a href="https://docs.github.com/es/github/writing-on-github/getting-started-with-writing-and-formatting-on-github/basic-writing-and-formatting-syntax">
                    Aprende a usar markadown aquí.
                </a>
            </span>
            <p>
                <a
                    href={catalogueDownloadLink}
                    download="respaldo-catalogo.json"
                >
                    Descargar un respaldo del catálogo.
                </a>
            </p>
        </div>
    );
};

export default ControlPanel;
